<template>
  
  <div>

    <md-card>
      <!-- <md-chip
      v-for="[item, name] in option_entries" 
      :key="name"
      :class="{
        'md-primary': value == item
      }" 
      md-clickable
      @click="$emit('input', item)"
      >
        {{ name }}
      </md-chip> -->
      <md-button
      v-for="[item, name] in option_entries" 
      :key="name"
      :class="{
        'md-raised md-primary': value == item, 
        'md-simple': value != item
      }" 
      @click="$emit('input', item)"
      >
        {{ name }}
      </md-button>
    </md-card>  

  </div>

</template>
<script>
export default {
  props: {
    value: {
      type: null,
      default: ""
    },
    options: [String, Array, Object],
  },
  computed: {
    option_entries(){
      switch(typeof this.options){
        case 'string': return this.options.split(',').map(i => [i,i]);
        case 'array':  return this.options.map(i => [i,i]);
        case 'object': 
          if(this.options instanceof Array){
            return Object.values(this.options).map(i => [i,i]);
          }else{
            return Object.entries(this.options);
          }
        default: return [];
      }
    },
  },
};
</script>
<style scoped lang="scss">
  @import "../../assets/scss/theme.scss";

  .md-card {
    flex-direction: row;
    width: fit-content;
    height: fit-content;
    margin: 0px;
    
    border: 1px solid $color-primary;

    // style 2, flat grey background
    background: rgba(0,0,0,0.1) !important;
    box-shadow: none;
    border: none;

    & button {
      // width: 60px;
      min-width: 60px;
      margin: 0px !important;

      color: $color-text;
      background: transparent !important;

      &.md-primary {
        color: $color-text-on-dark !important;
        background: $color-primary !important;
      }

      &::v-deep .md-ripple {
        padding: 12px 8px !important;
      }

    }

    &.wide {
      width: 100%;

    }
  
  }

  // .md-chip {
  //   width: 60px;
  //   min-width: 60px;

  //   // color: $color-text;
  //   // background: transparent !important;

  //   &.md-primary {
  //     color: $color-text-on-dark !important;
  //     // background: $color-primary !important;
  //   }

  // }

</style>
